module.exports = "/packs/media/images/icons/default_debt-a9b70f7cfadf547a2f9caf1d9e26bd02.png";